import { useMemo, useState } from "react"

const PLACEHOLDER = "/img/menu-placeholder.png"

// Tries `src`, then each `fallbackSrc`, then the shared menu placeholder, matching the native image views.
// `isPriority` is for rows that are on screen at first paint: the S3 origin answers in
// roughly a second, so deferring those to the lazy queue leaves visible empty thumbs.
export default function RemoteImage({ src, fallbackSrc, alt, className, isPriority = false }) {
  const fallbacks = Array.isArray(fallbackSrc) ? fallbackSrc : [fallbackSrc]
  const sourcesKey = [src, ...fallbacks].filter(Boolean).join("\n")
  const sources = useMemo(() => [...new Set(sourcesKey ? sourcesKey.split("\n") : [])], [sourcesKey])
  // Failures are keyed to the source list, so a new image never inherits an old failure.
  const [failure, setFailure] = useState({ key: sourcesKey, count: 0 })

  const attempt = failure.key === sourcesKey ? failure.count : 0
  const current = sources[attempt]
  const isPlaceholder = !current

  return (
    <img
      className={[className, isPlaceholder ? "is-placeholder" : ""].filter(Boolean).join(" ")}
      src={current ?? PLACEHOLDER}
      alt={alt}
      loading={isPriority ? "eager" : "lazy"}
      fetchPriority={isPriority ? "high" : "auto"}
      decoding="async"
      onError={() => {
        if (current) setFailure({ key: sourcesKey, count: attempt + 1 })
      }}
    />
  )
}
